import styled, { css } from 'styled-components';
import { theme } from '../../theme/GlobalTheme';

const baseButtonStyle = css`
  border: none;
  cursor: pointer;
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.fontSize.body};
  border-radius: ${theme.borderRadius.medium};
  transition: all 0.2s ease-in-out;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  outline: none;

  &:hover {
    text-decoration: none;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    
    &:hover {
      transform: none;
    }
  }

  i {
    margin-left: ${theme.spacing.sm};
  }
`;

export const PrimaryButton = styled.button`
  ${baseButtonStyle}
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  width: 250px;
  text-align: left;
  padding: 15px;
  min-height: 50px;

  &:hover {
    background-color: ${theme.colors.secondary};
    color: ${theme.colors.white};
  }
`;

export const SecondaryButton = styled.button`
  ${baseButtonStyle}
  background-color: ${theme.colors.white};
  color: ${theme.colors.primary};
  border: 2px solid ${theme.colors.primary};
  width: 250px;
  text-align: left;
  padding: 15px;
  min-height: 50px;

  &:hover {
    border-color: ${theme.colors.secondary};
    background-color: ${theme.colors.secondary};
    color: ${theme.colors.white};
  }
`;

export const CardButton = styled.button`
  ${baseButtonStyle}
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  min-width: 170px;
  text-align: left;
  padding: 15px;

  &:hover {
    background-color: ${theme.colors.secondary};
    color: ${theme.colors.white};
  }
`;

export const WhiteButton = styled.button`
  ${baseButtonStyle}
  background-color: ${theme.colors.white};
  color: ${theme.colors.primary};
  width: 250px;
  text-align: left;
  padding: 15px;
  min-height: 50px;

  &:hover {
    background-color: ${theme.colors.secondary};
    color: ${theme.colors.white};
  }
`;

export const NewProjectButton = styled.button`
  ${baseButtonStyle}
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  width: 250px;
  text-align: left;
  padding: 15px;
  height: 100px;
  border-radius: ${theme.borderRadius.large};
  font-weight: ${theme.typography.fontWeight.bold};

  &:hover {
    background-color: ${theme.colors.secondary};
    color: ${theme.colors.white};
  }
`;

export const SmallButton = styled.button`
  ${baseButtonStyle}
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  width: auto;
  min-width: auto;

  &:hover {
    background-color: ${theme.colors.secondary};
  }
`;

// Icon wrapper for consistent icon styling
export const ButtonIcon = styled.i`
  margin-left: auto;
  font-size: 14px;
`;
